import BorderBox1 from './main'
export default function (Vue) {
  Vue.component(BorderBox1.name, BorderBox1)
}



// WEBPACK FOOTER //
// ./src/components/border/border-box-1/index.js